import { render, staticRenderFns } from "./SmartCollabError.vue?vue&type=template&id=aceafb52&scoped=true&"
import script from "./SmartCollabError.vue?vue&type=script&lang=ts&"
export * from "./SmartCollabError.vue?vue&type=script&lang=ts&"
import style0 from "./SmartCollabError.vue?vue&type=style&index=0&id=aceafb52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceafb52",
  null
  
)

export default component.exports